import { render, staticRenderFns } from "./BidOrBuyModal.vue?vue&type=template&id=5404afb2&scoped=true&"
import script from "./BidOrBuyModal.vue?vue&type=script&lang=js&"
export * from "./BidOrBuyModal.vue?vue&type=script&lang=js&"
import style0 from "./BidOrBuyModal.vue?vue&type=style&index=0&id=5404afb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5404afb2",
  null
  
)

export default component.exports